// extracted by mini-css-extract-plugin
export default {"MobileOrb":"MobileAskAicaOrb_MobileOrb__l1Ebt"};